import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ServiceComponent } from './service/service.component';
import { AadharComponent } from './aadhar/aadhar.component';
import { PanComponent } from './pan/pan.component';
import { GstComponent } from './gst/gst.component';
import { DrivingComponent } from './driving/driving.component';
import { PassportComponent } from './passport/passport.component';
import { RcverifyComponent } from './rcverify/rcverify.component';
import { MsmeverifyComponent } from './msmeverify/msmeverify.component';
import { DinverifyComponent } from './dinverify/dinverify.component';
import { CinverifyComponent } from './cinverify/cinverify.component';
import { ContactusComponent } from './contactus/contactus.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { WhitecollarComponent } from './whitecollar/whitecollar.component';
import { BluecollarComponent } from './bluecollar/bluecollar.component';
import { GigworkerComponent } from './gigworker/gigworker.component';
import { RiskmanageComponent } from './riskmanage/riskmanage.component';
import { VendoronboardComponent } from './vendoronboard/vendoronboard.component';
import { DistributoronboardComponent } from './distributoronboard/distributoronboard.component';
import { DueDiligenceComponent } from './due-diligence/due-diligence.component';
import { KycSolutionComponent } from './kyc-solution/kyc-solution.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { RefundpolicyComponent } from './refundpolicy/refundpolicy.component';
import { HomePageComponent } from './home-page/home-page.component';
import { TestComponent } from './test/test.component';
import { WebsiteComponent } from './website/website.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SignupComponent } from './signup/signup.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ServiceComponent,
    AadharComponent,
    PanComponent,
    GstComponent,
    DrivingComponent,
    PassportComponent,
    RcverifyComponent,
    MsmeverifyComponent,
    DinverifyComponent,
    CinverifyComponent,
    ContactusComponent,
    AboutusComponent,
    WhitecollarComponent,
    BluecollarComponent,
    GigworkerComponent,
    RiskmanageComponent,
    VendoronboardComponent,
    DistributoronboardComponent,
    DueDiligenceComponent,
    KycSolutionComponent,
    TermsConditionComponent,
    PrivacypolicyComponent,
    RefundpolicyComponent,
    HomePageComponent,
    TestComponent,
    WebsiteComponent,
    SignupComponent,
    DisclaimerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
